import { Component } from '@angular/core';

@Component({
  selector: 'app-all-cases-list',
  templateUrl: './all-cases-list.component.html',
  styleUrls: ['./all-cases-list.component.css']
})
export class AllCasesListComponent {

}
